<template>
  <!-- 時間外コンポーネント(子) -->
  <div class="roster-cell roster-cell--overtime">
    <p class="roster-cell__value">
      <span>{{ overTimeResult[index] }}</span>
    </p>
  </div>
</template>

<script>
import ConstList from './../ConstList'
import { calculateRosterOvertime } from '@/utils/rosterOvertime'

export default {
  name: 'OverTime',
  props: {
    dailyWorkResult: {
      type: Array,
      required: true
    },
    attendance1: Array,
    attendance2: Array,
    workTimeUnit: Array,
    workBasic: Array,
    index: Number
  },
  computed: {
    overTimeResult () {
      return this.dailyWorkResult.map((workTime, i) => {
        if (!workTime) return null

        return calculateRosterOvertime({
          actualWork: workTime,
          basicWork: this.workBasic[i],
          workTimeUnit: this.workTimeUnit[i],
          isHoliday: this.attendance1[i] === ConstList.HOLIDAY
        })
      })
    }
  },
  watch: {
    // 時間外は勤務時間だけでなく、規定時間・最小単位・勤怠区分にも依存する。
    // 非同期ハイドレーション後も親の保存値を必ず更新する。
    overTimeResult: {
      immediate: true,
      deep: true,
      handler (values) {
        this.$emit('updateOverTime', {
          index: this.index,
          value: values[this.index]
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}
</style>
